import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import Jobfindbox from "../components/Element/Jobfindbox";
import { allJobs } from "../services/Data";
import { redirectUrl } from "../services/GlobalUrls";
import Background from "../images/new-updated-images/job-board/permanent-jobs/job-board-permanent-job.jpg";
import {
  jobContractType,
  jobTypeList,
  jobsEmploymentHours,
  jobsSalarytype,
} from "../services/JobTypeAndSectorGlobalList";
import logo2 from "../images/logo.png";
import { isMobileOrLaptop } from "../services/CheckDevice";
function includesIgnoringSpaces(str1, str2) {
  const formattedStr1 = str1.replace(/\s/g, "");
  const formattedStr2 = str2.replace(/\s/g, "");
  return formattedStr1.includes(formattedStr2);
}

const userType = localStorage.getItem("user_job_type");
const cndStatus = localStorage.getItem("permanentUserStatus");

const JobBoardMobile = ({ callArray }) => {
  const [recordsPerPage] = useState(6);
  const [allJobsRecords, setAllJobsRecords] = useState([]);
  const [filterJobsRecords, setAllFilterJobsRecords] = useState([]);
  const [area, setArea] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const data = {
    category: "",
    area: "",
    title: "",
    isHomePage: false,
    ...JSON.parse(localStorage.getItem("jobSearchDetails") || "{}"),
  };
  const [maxHeight, setMaxHeight] = useState("auto");
  const [currentPage, setCurrentPage] = useState(1);
  const [descriptionTextSize, setDescriptiongTextSize] = useState(0);
  const [jobsNotFound, setJobssNotFound] = useState(false);
  const [jsonArray, setJsonArray] = useState([]);

  // Sanitize Html Code - Start
  const sanitizeHtmlContent = (htmlContentCall) => {
    const htmlContent = `${
      '<text style={{color:"red"}}>' + htmlContentCall + "</text>"
    }`;

    const sanitizedHtmlContent = htmlContent
      .replace(/\s+/g, " ")
      .replace(/;/g, "")
      .replace(/\s+/g, "   ");

    return sanitizedHtmlContent;
  };
  // Sanitize Html Code - End

  // Remove Html Content - Start
  const removeHtmlTagsAndAttributes = (html) => {
    // Remove HTML tags
    const cleanHtml = html.replace(/<[^>]*>/g, "");
    // Remove HTML attributes
    const cleanText = cleanHtml.replace(
      /\s*([\w-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/g,
      ""
    );
    return cleanText;
  };
  // Remove Html Content - End

  const hideReadContent = () => {
    const multiIdsDiv = document.getElementById("mainJobContent");

    const elementsInsideDiv = multiIdsDiv.querySelectorAll("[id]");

    elementsInsideDiv.forEach((element) => {
      if (element.id && element.id.substr(0, 11) == "description") {
        let descriptionContent = document.getElementById(element.id);
        if (descriptionContent) {
          descriptionContent.style.display = "none";
        }
      }

      if (element.id && element.id.substr(0, 8) == "see_more") {
        let see_more = document.getElementById(element.id);
        if (see_more) {
          see_more.style.display = "block";
        }
      }
      if (element.id && element.id.substr(0, 8) == "see_less") {
        let see_less = document.getElementById(element.id);
        if (see_less) {
          see_less.style.display = "none";
        }
      }
    });
    // Multiple Form - End
  };

  // Read Less And More - Start
  const readLessAndMore = (callParam, callId, see_more, see_less) => {
    let callIdExecute = document.getElementById(callId);
    let seeMore = document.getElementById(see_more);
    let seeLess = document.getElementById(see_less);
    if (callParam == "see_more") {
      setMaxHeight("auto");
      if (callIdExecute) {
        callIdExecute.style.display = "block";
      }
      if (seeMore) {
        seeMore.style.display = "none";
      }
      if (seeLess) {
        seeLess.style.display = "block";
      }
      setDescriptiongTextSize(130);
    } else {
      setMaxHeight("250px");
      if (callIdExecute) {
        callIdExecute.style.display = "none";
      }
      if (seeMore) {
        seeMore.style.display = "block";
      }
      if (seeLess) {
        seeLess.style.display = "none";
      }
      setDescriptiongTextSize(0);
    }
  };
  // Read Less and More - End

  useEffect(() => {
    setAllJobsRecords(callArray);
    if (data.isHomePage) {
      const title1 = data.title?.trim() || "";
      const area1 = data.area?.trim() || "";
      const category1 = data.category?.trim() || "";

      const filteredJobs = (callArray || []).filter((job) => {
        const { jobs_location_town, jobs_title, job_sector_title } = job;
        const lowerCaseArea = jobs_location_town?.toLowerCase() || "";
        const lowerCaseTitle = jobs_title?.toLowerCase() || "";
        const lowerCaseCategory = job_sector_title?.toLowerCase() || "";

        const titleMatch = title1
          ? includesIgnoringSpaces(lowerCaseTitle, title1.toLowerCase())
          : true;
        const areaMatch = area1
          ? includesIgnoringSpaces(lowerCaseArea, area1.toLowerCase())
          : true;
        const categoryMatch = category1
          ? includesIgnoringSpaces(lowerCaseCategory, category1.toLowerCase())
          : true;

        const isMatch = titleMatch && areaMatch && categoryMatch;
        if (!isMatch) setJobssNotFound(true);
        else setJobssNotFound(false);
        return isMatch;
      });

      setArea(area1);
      setTitle(title1);
      setCategory(category1);
      setAllFilterJobsRecords(filteredJobs);
      setCurrentPage(1);
    } else {
      setAllFilterJobsRecords(callArray);
    }
  }, [callArray]);
  // Slice the data array to display only the data for the current page
  useEffect(() => {
    if (data.isHomePage) {
      handleSubmit(data.title, data.area, data.category);
      window.scrollTo(0, 400);
    }
  }, [area, title, category]);

  useEffect(() => {
    const listItems = document.querySelectorAll(".post-bx");
    let max = 0;

    listItems.forEach((item) => {
      const height = item.getBoundingClientRect().height;
      if (height > max) {
        max = height;
      }
    });

    setMaxHeight(max > 0 ? max + "px" : "250px");
  }, [allJobsRecords]);

  // Pagination logic
  const totalJobs = filterJobsRecords.length;
  const totalPages = Math.ceil(totalJobs / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = Math.min(startIndex + recordsPerPage, totalJobs);

  function handlePaginationClick(pageNumber) {
    setCurrentPage(pageNumber);
  }

  function handleSubmit(title1 = "", area1 = "", category1 = "") {
    const filteredJobs = allJobsRecords.filter((job) => {
      const { jobs_location_town, jobs_title, job_sector_title } = job;
      const lowerCaseArea = jobs_location_town
        ? jobs_location_town.toLowerCase()
        : "";
      const lowerCaseTitle = jobs_title ? jobs_title.toLowerCase() : "";
      const lowerCaseCategory = job_sector_title
        ? job_sector_title.toLowerCase()
        : "";

      if (
        (title1 &&
          !includesIgnoringSpaces(lowerCaseTitle, title1.toLowerCase())) ||
        (area1 &&
          !includesIgnoringSpaces(lowerCaseArea, area1.toLowerCase())) ||
        (category1 &&
          !includesIgnoringSpaces(lowerCaseCategory, category1.toLowerCase()))
      ) {
        setJobssNotFound(true);
        return false;
      }
      setJobssNotFound(false);
      return true;
    });

    setArea(area1);
    setTitle(title1);
    setCategory(category1);
    setAllFilterJobsRecords(filteredJobs);
    setCurrentPage(1); // Reset to first page when filters change
  }

  // Render pagination buttons
  function renderPaginationButtons() {
    const buttons = [];
    for (let i = 1; i <= totalPages; i++) {
      buttons.push(
        <li key={i} className={currentPage === i ? "active" : ""}>
          <Link
            to="#"
            onClick={(event, newInputValue) => {
              window.scrollTo(0, 300);
              handlePaginationClick(i);
              hideReadContent();
            }}
          >
            {i}
          </Link>
        </li>
      );
    }
    return buttons;
  }

  // Add title
  if (window.location.pathname == "/job-board") {
    document.getElementById("titleText").innerText =
      "Staffing Connect - Job Board Page";
  } else {
    document.getElementById("titleText").innerText =
      "Staffing Connect - Job Board(Permanent Jobs)";
  }

  let jobUrl = "";
  if (userType) {
    if (userType == "permanentrequirement") {
      if (cndStatus) {
        jobUrl = "/applied-jobs";
      } else {
        jobUrl = "/permanent-job-profile";
      }
    } else {
      jobUrl = "/dashboard";
    }
  } else {
    jobUrl = "/login";
  }

  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End



  return (
    <>
      <div
        className="dez-bnr-inr content-inner-2 dez-bnr-inr-md overlay-black-middle mt-10"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="container">
          <div className="dez-bnr-inr-entry">
            <h1 className="text-white">
              {area || title || category ? "Find Jobs" : "Job Board"}
            </h1>
            <div className="breadcrumb-row">
              <ul className="list-inline">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>{area || title || category ? "Find Jobs" : "Job Board"}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="section-full browse-job-find">
        <Jobfindbox
          allJobs={allJobsRecords}
          filteredJobs={filterJobsRecords}
          area={area}
          setArea={setArea}
          category={category}
          title={title}
          setTitle={setTitle}
          handleSubmit={handleSubmit}
        />
      </div>

      <div className="page-content bg-white">
        <div className="content-block ">
          {filterJobsRecords && filterJobsRecords.length > 0 ? (
            <>
              <div
                className="section-full bg-white browse-job p-b50 "
                style={{ marginTop: "0%" }}
              >
                <div className="container">
                  <ul
                    className="post-job-bx browse-job-grid row"
                    style={{ display: "flex", flexWrap: "wrap" }}
                    id="mainJobContent"
                  >
                    {filterJobsRecords
                      .slice(startIndex, endIndex)
                      .map((item, index) => (
                        <>
                          <li
                            className="col-lg-12 col-md-12"
                            key={index}
                            style={{
                              height: "auto",
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="post-bx p-4"
                              style={{
                                height: "100%",
                                borderRadius: "20px",
                              }}
                            >
                              <div className="row">
                                <div className="col-sm-12">
                                  <h3
                                    className="font-size-info mb-0 text-primary"
                                    style={{ fontWeight: "500" }}
                                  >
                                    <a
                                      className="text-primary"
                                      href={
                                        "/job-details" +
                                        (item?.jobs_title_url
                                          ? "/" + item?.jobs_title_url
                                          : "") +
                                        (item?.jobs_access_token
                                          ? "/" + item?.jobs_access_token
                                          : "")
                                      }
                                      style={{ fontSize: "80%" }}
                                      onClick={(event, input) => {
                                        const searchBarDetails = {
                                          title,
                                          area,
                                          category,
                                        };

                                        localStorage.setItem(
                                          "searchBarDetails",
                                          JSON.stringify(searchBarDetails)
                                        );
                                      }}
                                    >
                                      <text
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            sanitizeHtmlContent(
                                              item.jobs_title.slice(
                                                0,
                                                String(item.jobs_title)
                                                  .length != 0
                                                  ? String(item.jobs_title)
                                                      .length <= 30
                                                    ? item.jobs_title.length
                                                    : 28
                                                  : 28
                                              )
                                            ) +
                                            (item.jobs_title &&
                                            item.jobs_title.length > 30
                                              ? "..."
                                              : ""),
                                        }}
                                      ></text>
                                      {item.cnd_permanent_job_status ==
                                      "Applied" ? (
                                        <button
                                          class="btn btn-success btn-sm p-1 ml-1"
                                          aria-hidden="true"
                                          style={{
                                            borderRadius: "10px",
                                            fontSize: "40%",
                                          }}
                                        >
                                          Applied
                                        </button>
                                      ) : item.cnd_permanent_job_status ==
                                        "Draft" ? (
                                        <button
                                          class="btn btn-dark btn-sm p-1 ml-1"
                                          aria-hidden="true"
                                          style={{
                                            borderRadius: "10px",
                                            fontSize: "40%",
                                          }}
                                        >
                                          Draft
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                    </a>
                                  </h3>
                                  <text
                                    className="mb-1"
                                    style={{ fontSize: "90%" }}
                                  >
                                    {item.jobs_post_date}{" "}
                                    <a href="#" className="text-primary">
                                      Staffing Connect
                                    </a>
                                  </text>
                                  <ul className="nav navbar-nav">
                                    <li>
                                      <i
                                        className="fa fa-map-marker text-primary mr-2"
                                        style={{ fontSize: "18px" }}
                                      ></i>
                                      {item.jobs_location_town}
                                    </li>
                                    <li>
                                      <i
                                        className="fa fa-money text-primary mr-2"
                                        style={{ fontSize: "18px" }}
                                      ></i>
                                      {item.jobs_salary_details_display_salary_range_check ==
                                      1 ? (
                                        <>
                                          {"  £" +
                                            item.jobs_salary_details_min_salary +
                                            " - £" +
                                            item.jobs_salary_details_max_salary +
                                            " " +
                                            jobsSalarytype[
                                              item
                                                .jobs_salary_details_salary_type
                                            ]}
                                        </>
                                      ) : (
                                        <>
                                          {item.jobs_salary_details_display_options
                                            ? item.jobs_salary_details_display_options +
                                              " Salary"
                                            : ""}
                                        </>
                                      )}
                                    </li>
                                    <li>
                                      <i
                                        className="fa fa fa-clock-o text-primary mr-2"
                                        style={{ fontSize: "18px" }}
                                      ></i>
                                      {
                                        jobsEmploymentHours[
                                          item.jobs_job_type_employment_hours
                                        ]
                                      }
                                    </li>

                                    <li>
                                      <i
                                        className="fa fa-suitcase text-primary mr-2"
                                        style={{ fontSize: "18px" }}
                                      ></i>
                                      {String(
                                        jobContractType[
                                          item.jobs_job_type_contract_type
                                        ]
                                      ) &&
                                      jobContractType[
                                        item.jobs_job_type_contract_type
                                      ].length <= 30
                                        ? jobContractType[
                                            item.jobs_job_type_contract_type
                                          ]
                                        : jobContractType[
                                            item.jobs_job_type_contract_type
                                          ].slice(0, 30) + "..."}
                                    </li>

                                    {item.jobs_location_remote_location_check ==
                                      1 && (
                                      <li>
                                        <i
                                          className="fa fa-home text-primary mr-2"
                                          style={{ fontSize: "18px" }}
                                        ></i>
                                        Work from home
                                      </li>
                                    )}

                                    <div className="col-sm-12 mt-2 mb-0">
                                      <text style={{ fontStyle: "bold" }}>
                                        <div
                                          id={"description" + index}
                                          style={{ display: "none" }}
                                          className="mt-2"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              sanitizeHtmlContent(
                                                item.jobs_description.slice(
                                                  0,
                                                  item.jobs_description
                                                    .length != 0
                                                    ? item.jobs_description
                                                        .length / 10
                                                    : 150
                                                )
                                              ) + "...",
                                          }}
                                        />

                                        <b className="text-dark">
                                          <a
                                            className="cursor-pointer pull-right"
                                            id={"see_more" + index}
                                            onClick={() =>
                                              readLessAndMore(
                                                "see_more",
                                                "description" + index,
                                                "see_more" + index,
                                                "see_less" + index
                                              )
                                            }
                                          >
                                            <i
                                              className="fa fa-caret-down text-lg"
                                              style={{
                                                bottom: "0",
                                                fontSize: "18px",
                                              }}
                                            ></i>{" "}
                                            See more
                                          </a>
                                          <a
                                            className="cursor-pointer pull-right"
                                            style={{ display: "none" }}
                                            id={"see_less" + index}
                                            onClick={() =>
                                              readLessAndMore(
                                                "see_less",
                                                "description" + index,
                                                "see_more" + index,
                                                "see_less" + index
                                              )
                                            }
                                          >
                                            <i
                                              className="fa fa-caret-up text-lg"
                                              style={{
                                                bottom: "0",
                                                fontSize: "18px",
                                              }}
                                            ></i>{" "}
                                            See less
                                          </a>
                                        </b>
                                      </text>
                                    </div>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                        </>
                      ))}
                  </ul>

                  <div
                    className="pagination-bx m-t30 responsive"
                    style={{ overflow: "scroll" }}
                  >
                    <ul className="pagination">
                      <li className="previous">
                        <Link
                          to="#"
                          onClick={(event, newInputValue) => {
                            window.scrollTo(0, 200);
                            handlePaginationClick(Math.max(1, currentPage - 1));
                            hideReadContent();
                          }}
                        >
                          <i className="ti-arrow-left"></i>
                        </Link>
                      </li>
                      {renderPaginationButtons()}
                      <li className="next">
                        <Link
                          to="#"
                          onClick={(event, newInputValue) => {
                            handlePaginationClick(
                              Math.min(totalPages, currentPage + 1)
                            );
                            window.scrollTo(0, 200);
                            hideReadContent();
                          }}
                        >
                          <i className="ti-arrow-right"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {jobsNotFound == false && (
                <>
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12 text-center">
                        <center>
                          <p>
                            <h1
                              style={{ fontSize: "100px" }}
                              className="text-center text-primary"
                            >
                              <i class="fa fa-spinner fa-pulse"></i>
                            </h1>
                            <h3 className="text-center">Please wait</h3>
                          </p>
                        </center>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {jobsNotFound == true && (
                <>
                  <div
                    className="container text-center mt-4  mb-4"
                    style={{
                      backgroundColor: "#f8d7da",
                      color: "#721c24",
                      padding: "5px",
                      borderRadius: "25px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      fontWeight: "bold",
                    }}
                  >
                    <p className="mt-4">No Jobs found!</p>
                  </div>
                </>
              )}
              <br />
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default JobBoardMobile;
